'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    PENDING: '@@redux-pender/PENDING',
    SUCCESS: '@@redux-pender/SUCCESS',
    FAILURE: '@@redux-pender/FAILURE',
    CANCEL: '@@redux-pender/CANCEL',
    RESET: '@@redux-pender/RESET'
};

exports.default = actionTypes;